<template>
    <div class="table-td">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            id: { default : '' }
        }
    }
</script>
